import React, { Component } from "react";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ideaService from "../services/ideaService.js";
import userService from "../services/userService.js";
import Joi from "joi-browser";
import Swal from "sweetalert2";
import IdeaVotes from "./IdeaVotes.jsx";

class IdeaForm extends Component {
  state = {
    idea: { title: "", module: "General", description: "", active: true },
    errors: { title: "", description: "" },
    users: [],
  };
  schema = {
    title: Joi.string().required().label("Title"),
    description: Joi.string().required().label("Description"),
    id: Joi.number().label("id"),
    manualAdjustment: Joi.number().label("Adjustment"),
    module: Joi.string().required(),
    active: Joi.boolean(),
    created: Joi.date(),
    status: Joi.string().required().label("Status"),
  };
  constructor(props) {
    super(props);
    //await this.loadData();
    this.toggle = this.toggle.bind(this);
  }
  async componentDidMount() {
    await this.loadData();
  }
  async loadData() {
    if (this.props.mode === "edit") {
      const idea = await ideaService.getIdea(this.props.ideaId);
      const author = await userService.getUser(idea.authorId);
      this.setState({
        modal: false,
        idea: {
          id: idea.id,
          title: idea.title,
          module: idea.module,
          description: idea.description,
          active: idea.active,
          manualAdjustment: idea.manualAdjustment,
          created: idea.created,
          status: idea.status,
        },
        errors: { title: "", description: "" },
        author: author,
      });
    } else {
      this.setState({
        modal: false,
        idea: {
          title: "",
          module: "General",
          description: "",
          active: true,
          manualAdjustment: 0,
          status: "Under Consideration",
        },
        errors: { title: "", description: "" },
      });
    }
  }

  validate = () => {
    const result = Joi.validate(this.state.idea, this.schema, {
      abortEarly: false,
    });
    if (!result.error) return null;
    const errors = {};
    for (let item of result.error.details) errors[item.path[0]] = item.message;
    return errors;
  };

  toggle() {
    this.setState((prevState) => ({
      modal: !prevState.modal,
      idea: this.state.idea,
    }));
  }
  handleSubmit = async (e) => {
    e.preventDefault();
    this.submitButton.setAttribute("disabled", "disabled");
    const idea = { ...this.state.idea };

    const errors = this.validate();
    this.setState({ errors: errors || {} });
    if (errors) {
      this.submitButton.removeAttribute("disabled");
      return;
    }
    let result;
    idea.manualAdjustment = 0 + parseInt(idea.manualAdjustment, 10);

    if (this.props.mode === "edit") {
      result = await ideaService.updateIdea(idea);
    } else {
      result = await ideaService.createIdea(idea);
    }
    if (result.isOk) {
      this.setState({
        idea: {
          title: "",
          module: "General",
          description: "",
          manualAdjustment: 0,
        },
      });
      this.props.onSubmit(idea);
      Swal.fire({
        type: "success",
        title: "Thank you!",
        text: "Your suggestion will be considered by our product team",
      });
      this.toggle();
    } else {
      const errors = {};
      errors.submitResult = result.errorMessage;
      this.setState({ errors });
    }
    this.submitButton.removeAttribute("disabled");
  };
  handleChange = ({ currentTarget: input }) => {
    const idea = { ...this.state.idea };
    if (input.type === "checkbox") {
      idea[input.name] = input.checked;
    } else {
      idea[input.name] = input.value;
    }
    const errors = { ...this.state.errors };
    this.setState({ idea, errors });
  };
  renderIdeaLink() {
    if (this.props.mode === "edit") {
      return (
        <button className="btn btn-link" onClick={this.toggle}>
          {this.props.linkTitle}
        </button>
      );
    } else {
      return (
        <Button color="primary" onClick={this.toggle}>
          <FontAwesomeIcon icon="lightbulb" /> Suggest Improvement
        </Button>
      );
    }
  }
  render() {
    const { errors } = this.state;
    const closeBtn = (
      <button className="close btn btn-round" onClick={this.toggle}>
        &times;
      </button>
    );

    return (
      <span>
        {this.renderIdeaLink()}
        <form onSubmit={this.handleSubmit}>
          <Modal
            isOpen={this.state.modal}
            toggle={this.toggle}
            className={this.props.className}
          >
            <ModalHeader toggle={this.toggle} close={closeBtn}>
              Suggest Product Improvement
            </ModalHeader>
            <ModalBody>
              {errors.submitResult && (
                <div className="alert alert-danger">{errors.submitResult}</div>
              )}
              <div className="form-group">
                <label htmlFor="title">Title</label>
                <input
                  name="title"
                  onChange={this.handleChange}
                  type="text"
                  className="form-control"
                  id="title"
                  aria-describedby="emailHelp"
                  placeholder="Enter title"
                  required
                  value={this.state.idea.title}
                />
                {errors.title && (
                  <div className="alert alert-danger">{errors.title}</div>
                )}
                <small id="titleHelp" className="form-text text-muted">
                  Breif description of you suggestion
                </small>
              </div>
              <div className="form-group">
                <label htmlFor="module">Module</label>
                <select
                  className="form-control"
                  id="module"
                  name="module"
                  onChange={this.handleChange}
                  value={this.state.idea.module}
                >
                  <option>General</option>
                  <option>Core HR</option>
                  <option>Time and Attendance</option>
                  <option>Recruiting</option>
                  <option>Performance</option>
                  <option>Learning</option>
                  <option>Other</option>
                </select>
              </div>
              {this.props.mode === "edit" && (
                <div className=" form-group form-check">
                  <input
                    name="active"
                    onChange={this.handleChange}
                    type="checkbox"
                    className="form-check-input"
                    id="active"
                    required
                    checked={this.state.idea.active}
                  />
                  <label htmlFor="active">Active</label>
                </div>
              )}
              {this.props.mode === "edit" && (
                <div className=" form-group">
                  <label htmlFor="manualAdjustment">Manual Adjustment</label>
                  <input
                    name="manualAdjustment"
                    onChange={this.handleChange}
                    type="text"
                    className="form-control"
                    id="manualAdjustment"
                    required
                    value={this.state.idea.manualAdjustment}
                  />
                  {errors.manualAdjustment && (
                    <div className="alert alert-danger">
                      {errors.manualAdjustment}
                    </div>
                  )}
                </div>
              )}
              {this.props.mode === "edit" && (
                <div className="form-group">
                  <label htmlFor="module">Status</label>
                  <select
                    className="form-control"
                    id="status"
                    name="status"
                    onChange={this.handleChange}
                    value={this.state.idea.status}
                  >
                    <option>Under Consideration</option>
                    <option>Development in Process</option>
                    <option>Completed</option>
                  </select>
                </div>
              )}
              <div className="form-group">
                <label htmlFor="description">Description</label>
                <textarea
                  className="form-control"
                  id="description"
                  name="description"
                  rows="5"
                  onChange={this.handleChange}
                  value={this.state.idea.description}
                ></textarea>
                {errors.description && (
                  <div className="alert alert-danger">{errors.description}</div>
                )}
              </div>
              {this.state.author && (
                <div className="form-group">
                  <label>Author</label>
                  <div>
                    {this.state.author.fullName}{" "}
                    <span className="badge badge-primary">
                      {this.state.author.company}
                    </span>{" "}
                    {new Date(this.state.idea.created).toLocaleDateString() +
                      " " +
                      new Date(this.state.idea.created).toLocaleTimeString()}
                  </div>
                </div>
              )}
              {this.state.idea.id && <IdeaVotes ideaId={this.state.idea.id} />}
            </ModalBody>
            <ModalFooter>
              <button
                ref={(btn) => {
                  this.submitButton = btn;
                }}
                className="btn btn-primary"
                onClick={this.handleSubmit}
                type="submit"
              >
                Submit
              </button>{" "}
            </ModalFooter>
          </Modal>
        </form>
      </span>
    );
  }
}

export default IdeaForm;
